
<div class="motivation-featured-area bg-with-black-color">
    <div class="container-fluid mb-4">
        <div class="row justify-content-center">
            <div class="col-3">
                <h2 style="color: aliceblue;">VOTRE ENFANT,</h2>
            </div>
        </div>
    </div>
    <div class="container-fluid mt-5">
        <div class="row justify-content-center">
            <div class="col-lg-3 col-sm-6">
                <div class="motivation-featured-item">
                    <div class="icon">
                        <i class="flaticon-checkmark"></i>
                    </div>
                    <h3>
                        <a>Du lundi au vendredi dès la sortie des classes jusqu'à 21 heures</a>
                    </h3>
                    <p>Nous allons l'accueilir, le garder et le suivre dans son apprentissage.</p>
                    <a (click)="!collapse?collapse=true:collapse=false" role="button" class="featured-btn">En savoir plus +</a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6">
                <div class="motivation-featured-item">
                    <div class="icon">
                        <i class="flaticon-login"></i>
                    </div>
                    <h3>
                        <a>Du lundi au vendredi une équipe est disponible déjà à 7h</a>
                    </h3>
                    <p>De 18 mois à 4 ans, nous allons le garder, l'entretenir et lui offrir un programme d'éveil.</p>
                    <a (click)="!collapse?collapse=true:collapse=false" role="button" class="featured-btn">En savoir plus +</a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6">
                <div class="motivation-featured-item">
                    <div class="icon">
                        <i class="flaticon-credit-card"></i>
                    </div>
                    <h3>
                        <a>Dès sa scolarisation, tous les mercredis, samedis et dimanches</a>
                    </h3>
                    <p>Nous allons lui donner des cours de soutiens scolaires pour renforcer ses capacités.</p>
                    <a (click)="!collapse?collapse=true:collapse=false" role="button" class="featured-btn">En savoir plus +</a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6">
                <div class="motivation-featured-item">
                    <div class="icon">
                        <i class="flaticon-verify"></i>
                    </div>
                    <h3>
                        <a>Dès qu'il présente des difficultés à se concentrer, à retenir, à apprendre et à être autonome</a>
                    </h3>
                    <p>Nous allons le prendre en charge pour poser le diagnostic, définir les techniques d'apprentissage et lui donner une assistance psycho-affective.</p>
                    <a (click)="!collapse?collapse=true:collapse=false" role="button" class="featured-btn">En savoir plus +</a>
                </div>
            </div>
        </div>
        <div *ngIf="collapse" class="row justify-content-center">
            <div class="col-12 text-center">
                <p style="font-size: large;">Contactez le centre au <span style="color: #EFBE48">+229 97 213 717</span> ou envoyez-nous un mail sur <span style="color: #EFBE48">hello@cacebenin.bj</span></p>
            </div>
        </div>
    </div>
</div>